<template>
    <div class="no-select text-left title font-size-8 flex-fill">
        <div class="d-flex flex-column flex-md-row">
            <div style="width: 20.5rem">
                <div class="d-flex flex-row align-items-center">
                    <i class="el-icon-postcard mr-2"></i>
                    <span>Package:&nbsp;&nbsp;&nbsp;</span>
                    <span style="color: #212121; font-weight: 500">{{
                        element.packageName
                    }}</span>
                </div>
                <div class="d-flex flex-row align-items-center mr-4">
                    <i class="el-icon-cpu mr-2"></i>
                    <span>CPU:&nbsp;&nbsp;&nbsp;</span>
                    <span :title="element.detailChipset">
                        <v-clamp autoresize :max-lines="1">{{ element.detailChipset }}</v-clamp>
                    </span>
                </div>
                <div class="d-flex flex-row align-items-center">
                    <i class="el-icon-cpu mr-2"></i>
                    <span>GPU:&nbsp;&nbsp;&nbsp;</span>
                    <span style="color: #212121; font-weight: 500">
                        {{ element.numberCard }} x {{ element.detailGraphic }}
                    </span>
                </div>
                <!-- <div
          v-if="element.operatingSystem === operatingSystem.UBUNTU"
          class="d-flex flex-row align-items-center"
          title="Tera FLoating-point Operations Per Second"
        >
          <i class="el-icon-cpu mr-2"></i>
          <span>TFLOPS:&nbsp;&nbsp;&nbsp;</span>
          <span style="color: #212121; font-weight: 500">{{
            element.tflops
          }}</span>
        </div> -->
                <div class="d-flex flex-row align-items-center">
                    <i class="el-icon-box mr-2"></i>
                    <span>Installed:&nbsp;&nbsp;&nbsp;</span>
                    <div
                        v-if="element.masterDescription"
                        class=" d-flex flex-row justify-content-center align-items-center pb-1" >
                        <img
                            :src="`/icon/${element.masterDescription}.svg`"
                            style="height: 0.85rem"
                        />
                        <div class="ml-2 pt-1">{{ element.masterName }}</div>
                    </div>
                    <div v-else style="font-style: italic; opacity: 0.5">
                        None
                    </div>
                </div>
                <div class="d-flex flex-row align-items-center">
                    <i class="el-icon-money mr-2"></i>
                    <span>Price:&nbsp;&nbsp;&nbsp;</span>
                    <span>{{ element.priceHour }}</span>
                    <i class="el-icon-coin ml-1 mr-1"></i> / Machine / Hour
                </div>
            </div>
            <div>
                <div>
                    <i class="el-icon-cpu mr-2"></i>
                    <span>ID:&nbsp;&nbsp;&nbsp;</span>
                    <span style="color: #212121; font-weight: 500">{{
                        element.id
                    }}</span>
                    <span
                        v-if="element.fixedRental"
                        class="ml-2 mr-2"
                        style="opacity: 0.35"
                        >/</span
                    >
                    <!-- <span
            v-if="element.fixedRental"
            style="color: #388e3c; font-weight: 500"
            >{{ element.campaignName }} ({{ element.fixedRentalId }})</span
          > -->
                </div>
                <div>
                    <i class="el-icon-postcard mr-2"></i>
                    <span>Name:&nbsp;&nbsp;&nbsp;</span>
                    <span
                        style="
                            word-wrap: break-word;
                            color: #212121;
                            font-weight: 500;
                        "
                        >{{ element.name }}</span
                    >
                </div>
                <div>
                    <i class="el-icon-postcard mr-2"></i>
                    <span>Computer name:&nbsp;&nbsp;&nbsp;</span>
                    <span
                        style="
                            word-wrap: break-word;
                            color: #212121;
                            font-weight: 500;
                        "
                        >{{ element.deviceName }}</span
                    >
                </div>
                <div v-if="element.operatingSystem === operatingSystem.UBUNTU">
                    <i class="el-icon-connection mr-2"></i>
                    <span>SSH:&nbsp;&nbsp;&nbsp;</span>
                    <span
                        v-if="
                            element.canConnect &&
                            element.remoteAddress &&
                            element.sshPort
                        "
                    >
                        <el-tooltip
                            class="no-select item"
                            effect="light"
                            content="Click to copy SSH address"
                            placement="top"
                        >
                            <span
                                class="ssh"
                                style="font-weight: 500; cursor: pointer"
                                >{{ element.remoteAddress }}</span
                            >
                        </el-tooltip>
                        <span class="ml-1 mr-1">:</span>
                        <el-tooltip
                            class="no-select item"
                            effect="light"
                            content="Click to copy SSH port"
                            placement="top"
                        >
                            <span
                                class="ssh"
                                style="font-weight: 500; cursor: pointer"
                                >{{ element.sshPort }}</span
                            >
                        </el-tooltip>
                    </span>
                    <span v-else style="font-style: italic; opacity: 0.5"
                        >None</span
                    >
                </div>
                <div v-if="!element.fixedRental">
                    <div>
                        <i class="el-icon-time mr-2"></i>
                        <span>Estimate used:&nbsp;&nbsp;&nbsp;</span>
                        <span v-if="element.canBooting" style="color: #757575">
                            <span>0</span>
                            <i class="el-icon-coin ml-1"></i>
                        </span>
                        <span v-else style="color: #757575">
                            <span>{{ element.estimatedTotal }}</span>
                            <i class="el-icon-coin ml-1"></i>
                        </span>
                        <span class="ml-2 mr-2" style="opacity: 0.5">/</span>
                        <span v-if="element.canBooting" style="color: #757575"
                            >0m</span
                        >
                        <span v-else style="color: #42a5f5">{{
                            element.duration
                        }}</span>
                    </div>
                    <div
                        v-if="
                            element.startTime !== undefined &&
                            element.startTime !== null &&
                            (element.canShutdown || element.status === 11)
                        "
                    >
                        <i class="el-icon-date mr-2"></i>
                        <span>Start time:&nbsp;&nbsp;&nbsp;</span>
                        <span style="color: #9e9e9e">{{
                            element.startTime | pretyDateUtcToLocal
                        }}</span>
                    </div>
                    <div v-else>
                        <i class="el-icon-date mr-2"></i>
                        <span
                            >Created at:&nbsp;&nbsp;&nbsp;{{
                                element.createdAt | dateUtcToLocalFromNow
                            }}</span
                        >
                    </div>
                </div>
                <div v-else>
                    <div class="d-flex flex-row align-items-center">
                        <i class="el-icon-time mr-2"></i>
                        <span>Time remaining:&nbsp;&nbsp;&nbsp;</span>
                        <el-tooltip
                            class="item"
                            effect="dark"
                            :content="
                                element.continueRunning
                                    ? 'Keep machine running after expired'
                                    : 'Shutdown machine after expired'
                            "
                            placement="top"
                        >
                            <i
                                class="mr-1"
                                style="cursor: pointer; margin-right: 0.95rem"
                                :style="`color: ${
                                    element.continueRunning
                                        ? 'forestgreen'
                                        : 'red'
                                };`"
                                :class="`${
                                    element.continueRunning
                                        ? 'el-icon-monitor'
                                        : 'el-icon-switch-button'
                                }`"
                            ></i>
                        </el-tooltip>
                        <span
                            :style="`color: ${
                                element.fixedRentalTimeRemaining === 'Expired !'
                                    ? 'red'
                                    : '#1976D2'
                            }; font-weight: 500;`"
                            >{{ element.fixedRentalTimeRemaining }}</span
                        >
                    </div>
                    <div>
                        <i class="el-icon-date mr-2"></i>
                        <span>Start date:&nbsp;&nbsp;&nbsp;</span>
                        <span style="color: #e65100; font-weight: 500">{{
                            element.startDate | pretyDateUtcToLocal
                        }}</span>
                    </div>
                    <div>
                        <i class="el-icon-date mr-2"></i>
                        <span>End date:&nbsp;&nbsp;&nbsp;</span>
                        <span style="color: #e65100; font-weight: 500">{{
                            element.endDate | pretyDateUtcToLocal
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { OPERATING_SYSTEM } from "@/constant/rental";
import VClamp from 'vue-clamp';
export default {
    components: {
        VClamp
    },
    data() {
        return {
            operatingSystem: OPERATING_SYSTEM,
        };
    },

    props: {
        element: {
            type: Object,
            default() {
                return {};
            },
        },
    },
};
</script>